/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_PublishInputs */

const en_inbox_na_publish = /** @type {(inputs: Inbox_Na_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const id_inbox_na_publish = /** @type {(inputs: Inbox_Na_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Inbox_Na_PublishInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_publish = /** @type {((inputs?: Inbox_Na_PublishInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_PublishInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_publish(inputs)
	return en_inbox_na_publish(inputs)
});